<template>
  <div class="bgView">
     <div class="header">
      <div class="title" >选择项目</div>
      <img class="addBtn" :src="addImg" @click="addProject"/>
     </div>
    <div class="projectList">
      <div v-for="(item,index) in projectLists" :key="index">
          <div class="projectItem" :class="selectedProject == item?'selected':'normal'"
          @click="selectProject(item)">
          <div class="projectItemTitle">{{item.projectName}}</div>
          <div class="operationBox">
            <img :src="modifyImg" style="margin-right:10px" class="operationImg" @click="modifyBtnClicked(item)" />
            <img :src="deleteImg" class="operationImg" @click="deleteBtnClicked(item)" />
          </div>
         
          </div>
      </div>
      <div v-if="projectLists.length === 0" style="color:rgba(255,255,255,0.6)">暂无项目</div>
    </div>
   
      
    <project-add v-if="isShowProjectAdd" :isUpdate="isUpdate"
    :selectedProjectId="updateProjectId" @receiveClose="receiveClose"></project-add>
  </div>
</template>

<script>
import ProjectAdd from './ProjectAdd.vue'
export default {
  name: 'Project',
  data () {
    return {
      addImg:require('../assets/images/add.png'),
      modifyImg: require('../assets/images/modify.png'),
      deleteImg: require('../assets/images/delete.png'),
      projectLists:[],
      selectedProject:null,
      isShowProjectAdd:false,
      isUpdate:false,
      updateProjectId:''
    }
  },
  components:{
    ProjectAdd
  },
  mounted() {
    this.getProjectList();
  },
  methods: {
    getProjectList() {
      let url = baseIp + 'project/getProjectList'
      let param = new FormData();
      param.append("userId",localStorage.getItem('userId'));
      let config = {
        headers:{
          // 'Content-Type':'application/json; charset=utf-8',
          "token":localStorage.getItem('token')
          ,"Access-Control-Allow-Origin":'*'
        }
      };
      console.log(url);
      this.$ajax.post( url,param,config)
      .then((res)=>{
        if (res.data.code == 200) {
          this.projectLists = res.data.data;
        
        }
        else {
            $alertBox.alert({

              message:res.data.message
            })
        } 

        // this.$set("item","selected",false);
        // this.datas.forEach(item=>{
        //   item.photo = baseIp +'student/viewPhoto/'+ item.photo;
        // })
      })
    },
    addProject () {
      this.isUpdate = false;
      this.updateProjectId = '';
      this.isShowProjectAdd = true;
    },
     modifyBtnClicked(item) {
      this.isUpdate = true;
      this.updateProjectId = item.projectId;
      console.log("this.updateProjectId",this.updateProjectId);
      this.isShowProjectAdd = true;
    },
    deleteBtnClicked(item) {
      console.log("item",item);
      console.log(item.projectId);
      var _this = this;
      $alertBox.alert({
        message:"确定要删除这个项目吗？",
        onConfirm() {
          _this.deleteProject(item.projectId);
        }
      })
    },
    deleteProject(projectId) {
      let url = baseIp + 'project/deleteProject'
      let param = new FormData();
      param.append("projectId",projectId);
      let config = {
        headers:{
          "token":localStorage.getItem('token')
          ,"Access-Control-Allow-Origin":'*'
        }
      };
      console.log(url);
      this.$ajax.post( url,param,config)
      .then((res)=>{
        if (res.data.code == 200) {
         console.log("删除成功");
         this.getProjectList();
        
        }
        else {
            $alertBox.alert({

              message:res.data.message
            })
        } 
      })
    },
    selectProject(item) {
      this.selectedProject = item;
      console.log("item = ",item)
      this.$emit('onSelectProject',item);
    },
    receiveClose () {
      this.isShowProjectAdd = false;
      this.getProjectList();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bgView {
  width:260px;
  height: 300px;
  top: 60px;
  left: 60px;
  position: absolute;
  background: #000000a0;
  display: flex;
  flex-direction: column;
}

.header {
  width:100%;
  height: 40px;
  position: relative;
  color: white;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #cccccc;
  background: black;
  opacity: 0.5;
}
.title {
  width:100%;
  height:100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
 
}

.addBtn {
  width:20px;
  height:20px;
  right:10px;
  position: absolute;
  cursor: pointer;
}

.projectList {
  width:100%;
  height: calc(100% - 40px);
  position: relative;
  color:white;
  /* cursor: pointer; */
}
.projectItem {
  height: 40px;
  border-bottom: 0.5px solid #cccccc80;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
}

.normal {
  background: transparent;
}
.selected {
  background: rgb(90, 90, 159);
  
}
.projectItemTitle {
  width:calc(100% - 70px);
  height: 100%;
  padding-left: 15px;
  position: absolute;
  text-align: left;
  display: flex;
  align-items: center;
}
.operationBox {
  width:auto;
  height: 100%;
  right:10px;
  position: absolute;
  display: flex;
  align-items: center;
}

.operationImg {
  width:20px;
  height:20px;
  position: relative;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/Project.vue